import { render, staticRenderFns } from "./AttachmentInput.vue?vue&type=template&id=6ec7db60&scoped=true&"
import script from "./AttachmentInput.vue?vue&type=script&lang=js&"
export * from "./AttachmentInput.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentInput.vue?vue&type=style&index=0&id=6ec7db60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7db60",
  null
  
)

export default component.exports